module.exports = __webpack_public_path__ + "static/media/ic_pc_active.15d3c1ec.svg";